export const strokeJoinRoundIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9 3a6 6 0 0 0-6 6v11h2V9c-.006-2.213 1.787-4 4-4h11V3H9zm0 6v4h1v7h2v-7h1v-1h7v-2h-7V9H9zm6 6v5h2v-3h3v-2h-5z"/></svg>`,
  name: 'stroke-join-round',
};
